<template>
  <div>
    {{code}} - {{company}}
  </div>
</template>

<script>
export default {
  name: 'CellRendererEquipment',
  data() {
    return {
      equipmentId: null,
      code: null,
      company: null
    }
  },
  created() {
    this.code = this.params.value.code;
    this.company = this.params.value.company;
  }
}
</script>
